import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Bmi, BmiApi, Notifications } from '@types-lib';
import { SnackNotificationsDialogService } from '@ui-lib/services';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';
import { catchError, Observable } from 'rxjs';

export class SetOrderBodyMassIndexInfoOrTreatmentStartDataEndpoint<
  T extends Bmi.SaveBmiItemReq | Bmi.TreatmentStartInfoSaveReq,
> {
  private env = inject<PIMSEnvironment>(ENVIRONMENT);
  private http = inject(HttpClient);
  private snackBar = inject(SnackNotificationsDialogService);

  put(request: T): Observable<BmiApi.SavedBmiItem> {
    return this.http
      .put<BmiApi.SavedBmiItem>(
        `${this.env.constants.ADMIN_API_URL}/admin/${request.user_id}/bodymassindex`,
        request,
      )
      .pipe(
        catchError((err: HttpErrorResponse) => {
          console.error(err);
          this.snackBar.openErrorMessage(Notifications.generic.failure);
          throw err;
        }),
      );
  }
}
